import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'

export const GrayWrap = styled(Stack)`
  border-radius: 6px;
  padding: 12px;
  color: ${(props) => props.theme.color?.text60};
  background: ${(props) => props.theme.color?.bgLightGray};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
`

export const FaucetTips = styled(Stack)`
  flex-direction: row;
  font-size: 12px;
  color: ${(props) => props.theme.color?.text90};

  span {
    color: #2329c3;
    cursor: pointer;
  }

  .iconfont {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-left: 4px;
    color: ${(props) => props.theme.color?.primary30};
    border: 1px solid ${(props) => props.theme.color?.primary30};

    border-radius: 50%;
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme.color?.bg};
      background: ${(props) => props.theme.color?.primary30};
    }
  }
  strong {
    margin: 0 4px;
  }
`
